// @ts-strict-ignore
import {ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {BaseRegistrationForm} from '../base-registration-form';
import {FieldKey, ValidationState} from '../constants';
import {InvitationStep} from './constants';
import {AuthInvitationFormState} from './types';
import {template} from './template';

export class AuthInvitationForm extends BaseRegistrationForm {
  isInvited = true;
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      inviter: `string`,
      'users-preview': {
        type: `json`,
        tsType: `MixpanelUserItem[]`,
      },
      'users-total': `number`,
      'is-uber': `boolean`,
    };
  }

  get config(): ConfigOptions<AuthInvitationFormState> {
    const baseConfig = super.baseConfig();
    return {
      ...baseConfig,
      template,
      defaultState: {
        ...baseConfig.defaultState,
        step: InvitationStep.Default,
      },
      helpers: {
        ...baseConfig.helpers,
      },
    };
  }

  getStepFor() {
    return InvitationStep.Default;
  }

  getValidationStatus(field) {
    const {formErrors} = this.state;
    // show error state for email field if already-invited-error exist
    if (field === FieldKey.Email && (this.attr(`already-invited-error`) || formErrors.alreadyInvitedError)) {
      return ValidationState.Invalid;
    }
    // when invited, email is pre-filled so it's valid
    if (field === FieldKey.Email) {
      return ValidationState.Valid;
    }
    if (field in formErrors) {
      return formErrors[field] ? ValidationState.Invalid : ValidationState.Valid;
    }
    return ValidationState.NotValidated;
  }

  getExtraSignupOptions() {
    if (this.attr(`inviter`)) {
      return {
        inviter: this.attr(`inviter`),
      };
    }
    return {};
  }

  handleGoogleCredentialResponse(socialCredential) {
    const {formValues} = this.state;
    formValues.socialCredential = socialCredential;
    this.update({formValues});
    this.handleSignup();
  }

  handleSignup() {
    let isValid = true;
    // Magic Link and Social Sign-Up flows are mutually exclusive - users who do not have a social credential are magic link
    const isMagicLinkRegistration =
      this.state.formValues.enableMagicLinkRegistration && !this.state.formValues.socialCredential;
    // Magic link registration only requires email and ToU; social registration requires no fields
    if (isMagicLinkRegistration) {
      isValid = this.validateFormFields([FieldKey.AgreedToTermsOfUse, FieldKey.Email]);
    } else if (!this.state.formValues.socialCredential) {
      isValid = this.validateFormFields([
        FieldKey.AgreedToTermsOfUse,
        FieldKey.Name,
        FieldKey.Department,
        FieldKey.Email,
        FieldKey.Password,
      ]);
    }
    // if validation passes
    if (!this.attr(`already-invited-error`) && isValid) {
      this.createSignupAccount();
    }
  }
}

export const AuthInvitationFormEl = defineAndMakeJsxFactory(`auth-invitation-form`, AuthInvitationForm);
